import { defineMessages } from 'react-intl';

export default defineMessages({
  resultIsCalculated: 'Wynik w trakcie obliczania. Spróbuj ponownie za chwilę.',
});
